import PropTypes from 'prop-types';
import ParticipantIconsInlineImpl from './participant-icons-inline.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * @class ParticipantIconsInline
 * @memberof Mojito.Presentation.Components
 */

/**
 * ParticipantIconsInline prop types.
 *
 * @property {Array} participants - Sorted participants array (at least 2 items).
 * @property {string} sportId - Sport identifier for CompetitorIcon.
 * @property {string} separator - Separator character to display between icons.
 *
 * @memberof Mojito.Presentation.Components.ParticipantIconsInline
 */
const propTypes = {
    participants: PropTypes.array.isRequired,
    sportId: PropTypes.string,
    separator: PropTypes.string,
};

export default UIView('ParticipantIconsInline', ParticipantIconsInlineImpl, propTypes);
